export const MAX_EXPORT_CSV_DAYS_RANGE = 31
export const CREATE_OPTION = 'create-option'
export const CLEAR = 'clear'
export const SNC_QUESTIONS_PAGE_SIZE = 15
export const SNC_ANSWERS_PAGE_SIZE = 20
